// Angular
import { ChangeDetectionStrategy, Component, OnInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
// Constant
import { SAVE_PART_LS_KEY } from '@constants';
// Utils
import { CommonService } from '@core/utils';
// Environment
import { environment } from '@environment';
// RxJS
import { filter, Observable } from 'rxjs';
// Modules
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
// Pipe
import { MakeMePrettyPipe } from '@app/core/_base/layout';

@Component({
  selector: 'app-mobile-menus',
  templateUrl: './mobile-menus.component.html',
  styleUrls: ['./mobile-menus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, RouterLinkActive, RouterLink, AsyncPipe, MakeMePrettyPipe]
})
export class MobileMenusComponent implements OnInit {

  // Private
  private readonly translocoService = inject(TranslocoService);
  private readonly cs = inject(CommonService);
  private router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  activeOffcanvas = inject(NgbActiveOffcanvas);


  // Public
  languageChange$: Observable<string>;
  totalSavedParts: number = 0;
  flags = environment.vehicleTypeConfigFlag;

  /**
   * On Init
   * @memberof MobileMenusComponent
   */
  ngOnInit(): void {
    // Get Current live language
    this.languageChange$ = this.translocoService.langChanges$;

    // Get Saved parts count
    const parts = this.cs.getFromLocalStorage(SAVE_PART_LS_KEY);
    this.totalSavedParts = parts ? parts.length : 0;

    // Close quick panel if route changed
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.activeOffcanvas.close();
    });
  }
}